import { Record, List } from 'immutable';

export default class StatisticRecord extends Record({
  id: null,
  date: null,
  bookingCount: null,
  eventCount: null,
  customerFee: null,
  profit: null,
  periodizedProfit: null,
  periodizedCustomerFee: null,
  workingResources: new List(),
}) {
}
